import store from "../store-root";
import api from "../../service/api";

const moduleName = "permission";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    qlwPermissions: null
  },
  mutations: {
    setQlwPermissions(state, payload) {
      state.qlwPermissions = payload;
    },
    clearQlwPermissions(state) {
      state.qlwPermissions = null;
    }
  },
  actions: {
    async GetQlwPermissions({ commit }) {
      const result = await api.get("/api/User/QlwPermissions");
      const permissions = Array.isArray(result.data) ? result.data : [];
      commit("setQlwPermissions", permissions);
      return permissions;
    }
  }
});

export default moduleName;
